import React, { useEffect, useMemo, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './StudentNew.css'
import '../Superadmin/NewWork/AddBranch.css'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import { AiOutlineRight } from 'react-icons/ai';
import { AiOutlineLeft } from 'react-icons/ai';
import { useResizeDetector } from 'react-resize-detector';
import { useAppStore, useStudentOptionsStore } from '../../stores';
import { useImmer } from 'use-immer';
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";

const toastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

const isOverflown = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }) => {
    return scrollHeight > clientHeight || scrollWidth > clientWidth;
}
const handleScroll = (e, DIR) => {
    if (DIR === "LEFT") {
        e.currentTarget.previousSibling.scrollLeft += 30;
    }
    else {
        e.currentTarget.nextSibling.scrollLeft -= 30;
    }
}
const handleScrollItems = (e, cb) => {
    e.currentTarget.parentElement.querySelectorAll(".highlight").forEach(ele => ele.classList.remove("highlight"));
    e.currentTarget.classList.add("highlight");
    cb && cb();
}
const DegreeCard = ({ name, _id, code, degree }) => {
    const handleSubmit = (e) => {
        showLoading();
        if (!formData.batch || !formData.sem || !formData.year || !_id || !degree) {
            toast.error("Please select all fields", toastOptions);
            hideLoading();
            return;
        }
        console.log(section);
        navigate(`/files/subjects/${formData.batch}/${section._id}`);
        hideLoading();
    }
    const [show, setShow] = useState(false);
    const modalRef = useRef(null);
    const navigate = useNavigate();
    const showLoading = useAppStore(state => state.showLoading);
    const hideLoading = useAppStore(state => state.hideLoading);
    const getYears = useStudentOptionsStore((state) => state.getYears);
    const getSems = useStudentOptionsStore((state) => state.getSems);
    const years = getYears({ branch: _id, degree: degree });
    const getBatches = useStudentOptionsStore((state) => state.getBatches);
    const [formData, setFormData] = useImmer({ year: years[0], sem: 1, batch: null });
    const getSections = useStudentOptionsStore(state => state.getSections);
    const section = getSections({ branch: _id, year: formData.year, sem: formData.sem })[0];
    const bats = getBatches({ year: formData.year, branch: _id });
    const batches = useMemo(() => bats, [formData.year]);
    console.log("Year", formData);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        // modalRef.current = { ...modalRef.current, branch: _id, name: name }
        // console.log(modalRef.current);
        setShow(true);
    };

    useEffect(() => {
        // if (!formData.batch) {
        setFormData(draft => {
            draft.batch = batches[0];
        })
        // }
    }, [formData.year])

    const { width, height, ref } = useResizeDetector();
    useEffect(() => {
        if (show) {
            document.querySelectorAll(".itemsscroll").forEach(ele => {
                if (!isOverflown({ clientWidth: ele.clientWidth, scrollWidth: ele.scrollWidth })) {
                    ele.classList.add("itemUnderFlown");
                    ele.previousSibling.style.display = 'none';
                    ele.nextSibling.style.display = 'none';
                }
                else {
                    ele.classList.remove("itemUnderFlown");
                    ele.previousSibling.style.display = 'inline';
                    ele.nextSibling.style.display = 'inline';
                }
            });
        }
    }, [width, height, show])
    return (
        <div class="col-6 col-sm-4 col-md-3 col-lg-2 mt-2 degreebranch" ref={ref}>
            <div className="card branchcard" onClick={handleShow}>
                <div class="card-body">
                    <h5 class="card-title UPPERCASE">{code}</h5>
                </div>
            </div>

            <Modal show={show} onHide={handleClose} ref={modalRef}>
                <Modal.Header closeButton>
                    <Modal.Title><span className='UPPERCASE'>{code}&ensp;</span>-&ensp;Select required details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <>
                            <h3>Year</h3>
                            <div className="m-0 p-0 mainStudent" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

                                <div style={{ width: "8%" }} onClick={(e) => handleScroll(e, "RIGHT")}>
                                    <div className='d-flex' style={{ justifyContent: "center" }}><AiOutlineLeft className='arrowstudent' /></div>
                                </div>
                                <div className='itemsscroll' >
                                    {years.map((yr, index) => <h3 className={"me-2 ms-2" + (index === 0 ? " highlight" : "")} onClick={(e) => handleScrollItems(e, () => setFormData(draft => void (draft.year = yr)))} style={{ cursor: "pointer" }}>{yr}</h3>)}
                                </div>
                                <div style={{ width: "8%" }} onClick={(e) => handleScroll(e, "LEFT")}>
                                    <div className='d-flex' style={{ justifyContent: "center" }}><AiOutlineRight className='arrowstudent' /></div>
                                </div>
                            </div>
                        </>
                        <>
                            <h3>Semester</h3>
                            <div className="m-0 p-0 mainStudent" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

                                <div style={{ width: "8%" }} onClick={(e) => handleScroll(e, "RIGHT")}>
                                    <div className='d-flex' style={{ justifyContent: "center" }}><AiOutlineLeft className='arrowstudent' /></div>
                                </div>
                                <div className='itemsscroll' >
                                    <h3 className="me-2 ms-2 highlight" onClick={(e) => handleScrollItems(e, () => setFormData(draft => void (draft.sem = 1)))} style={{ cursor: "pointer" }}>1</h3>
                                    <h3 className="me-2 ms-2" onClick={(e) => handleScrollItems(e, () => setFormData(draft => void (draft.sem = 2)))} style={{ cursor: "pointer" }}>2</h3>
                                </div>
                                <div style={{ width: "8%" }} onClick={(e) => handleScroll(e, "LEFT")}>
                                    <div className='d-flex' style={{ justifyContent: "center" }}><AiOutlineRight className='arrowstudent' /></div>
                                </div>
                            </div>
                        </>
                        <>
                            <h3>Batches</h3>
                            <div className="m-0 p-0 mainStudent" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ width: "8%" }} onClick={(e) => handleScroll(e, "RIGHT")}>
                                    <div className='d-flex' style={{ justifyContent: "center" }}><AiOutlineLeft className='arrowstudent' /></div>
                                </div>
                                <div className='itemsscroll' >
                                    {batches.map((bat, index) => <h3 style={{ cursor: "pointer" }} className={"me-2 ms-2 " + (formData.batch === bat ? "highlight" : "")} onClick={(e) => handleScrollItems(e, () => setFormData(draft => void (draft.batch = bat)))}>{bat}</h3>)}
                                </div>
                                <div style={{ width: "8%" }} onClick={(e) => handleScroll(e, "LEFT")}>
                                    <div className='d-flex' style={{ justifyContent: "center" }}><AiOutlineRight className='arrowstudent' /></div>
                                </div>
                            </div>
                        </>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <button className="SearchBtn col-md-4 m-2" onClick={handleSubmit}>Search</button>
                    </div>

                </Modal.Body>
            </Modal>
        </div>
    )
}

export default DegreeCard